import {
  KibField,
  KibSuperSelect,
  type KibSuperSelectOption,
} from '@chewy/kib-fields-new-react'
import { KibSearchIcon } from '@chewy/kib-icons-react'
import classNames from 'classnames'

import type { NamedEntity } from '~/api/graphql/generated/types'
import type { FilterOption } from '~/components/common/filters/BaseFilter'

import styles from './KibSearchableSelect.module.scss'

export interface KibSearchableSelectProps {
  onChange?: (selection: FilterOption) => void
  options: NamedEntity[]
  placeholder: string
  selectedValues: string[]
}

export const KibSearchableSelect = ({
  options,
  selectedValues,
  placeholder,
  onChange,
}: KibSearchableSelectProps) => {
  const kibOptions: KibSuperSelectOption[] = options.map((option) => ({
    label: option.name,
    value: option.id,
  }))

  const selectedOptions = kibOptions.filter((option) =>
    selectedValues.includes(option.value),
  )

  const handleKibChange = (newOptions: KibSuperSelectOption[]) => {
    const value = newOptions.map((option) => option.value)
    const humanReadable = newOptions.map((option) => option.label).join(', ')
    onChange?.({ value, humanReadable })
  }

  return (
    <div className={styles.kibScope}>
      <KibField
        clearable={selectedValues.length > 0}
        icon={<KibSearchIcon />}
        label=""
        renderControl={(controlProps) => (
          <KibSuperSelect
            label=""
            {...controlProps}
            multiSelect
            className={classNames(styles.hideArrow, styles.customDropdown)}
            options={kibOptions}
            placeholder={placeholder}
            value={selectedOptions}
            onChange={handleKibChange}
          />
        )}
        onClear={() => handleKibChange([])}
      />
    </div>
  )
}

export default KibSearchableSelect
